import i18n from 'i18next';
import type { MiddlewareFunction } from 'react-router';
import { isBetaEnabled } from '~/common/app/beta';
import { getLocaleOptionsForEvaluator } from '~/utils/evaluatorLocales';

export async function applyQueryDialect({
  url,
}: MiddlewareArgs): Promise<void> {
  const dialect = url.searchParams.get('dialect');

  if (dialect && isEvaluatorDialect(dialect) && dialect !== appliedDialect) {
    await i18n.changeLanguage(dialect);
    appliedDialect = dialect;
  }
}

type MiddlewareArgs = Parameters<MiddlewareFunction>[0];

let appliedDialect: string | null = null;

function isEvaluatorDialect(dialect: string): boolean {
  return getLocaleOptionsForEvaluator(undefined, isBetaEnabled()).some(
    (locale) => locale.tag === dialect,
  );
}

export function clearAppliedDialect(): void {
  appliedDialect = null;
}
